import React from "react";
import "./Footer.css";
import { FaLinkedin, FaGithub, FaAngleUp } from "react-icons/fa";

const Footer = () => {
  // Smooth scroll handler to hop back up to the hero section seamlessly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="portfolio-footer">
      <div className="footer-divider-line"></div>
      
      <div className="footer-container">
        {/* Left Side: Personal Branding Brand */}
        <div className="footer-brand-box">
          <h3 className="footer-logo-text">Chitrarasu<span>.dev</span></h3>
          <p className="footer-tagline">
            Building scalable frontend systems and robust backend architectures.
          </p>
        </div>

        {/* Middle Side: Quick Section Map Links */}
        <div className="footer-nav-box">
          <h4 className="footer-heading">Navigation</h4>
          <ul className="footer-links-list">
            <li><a href="#about">About</a></li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#certifications">Certifications</a></li>
          </ul>
        </div>

        {/* Right Side: Social Connections & Action */}
        <div className="footer-social-box">
          <h4 className="footer-heading">Connect</h4>
          <div className="footer-social-row">
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://github.com" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="GitHub">
              <FaGithub />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Segment: Copyright & Back-to-Top Toggle Button */}
      <div className="footer-bottom-bar">
        <p className="copyright-text">
          &copy; {new Date().getFullYear()} Chitrarasu. All Rights Reserved.
        </p>
        
        <button className="scroll-top-btn" onClick={scrollToTop} aria-label="Scroll back to top">
          Back to Top <FaAngleUp className="arrow-up-icon" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;